"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("./");
const Css_1 = require("../Css");
const utils_1 = require("../utils");
/** Tag used for indicating a status */
function Tag({ text, type, xss, ...otherProps }) {
    const typeStyles = getStyles(type);
    const tid = (0, utils_1.useTestIds)(otherProps);
    return ((0, jsx_runtime_1.jsxs)("span", { ...tid, css: { ...Css_1.Css.dif.tinySb.ttu.aic.gapPx(4).pxPx(6).pyPx(2).gray900.br4.$, ...typeStyles, ...xss }, title: text, children: [otherProps.icon && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.$, children: (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: otherProps.icon, inc: 1.5 }) })), (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.lineClamp1.breakAll.$, children: text })] }));
}
exports.Tag = Tag;
function getStyles(type) {
    switch (type) {
        case "info":
            return Css_1.Css.bgLightBlue100.$;
        case "caution":
            return Css_1.Css.bgYellow200.$;
        case "warning":
            return Css_1.Css.bgRed100.$;
        case "success":
            return Css_1.Css.bgGreen100.$;
        default:
            // Neutral case
            return Css_1.Css.bgGray200.$;
    }
}
